// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const ENVIRONMENT = {
  production: false,
  firebaseConfig: {
    apiKey: 'AIzaSyD0Vqn3kplpVrhJZ46rh3lI8MPRb35l7bU',
    authDomain: 'edit-design.firebaseapp.com',
    databaseURL: 'https://edit-design.firebaseio.com',
    projectId: 'edit-design',
    storageBucket: 'edit-design.appspot.com',
    messagingSenderId: '1053510108925',
    appId: '1:1053510108925:web:aa6dff98bf75704834a094'
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.

